<div class="profile-form-container" [class.compact]="size() === 'small'">
  <form [formGroup]="profileForm" (ngSubmit)="onSubmit()">

    <!-- Large Size Header -->
    <div class="form-header" *ngIf="size() === 'large'">
      <div class="header-icon">
        <i class="bi bi-person-plus-fill"></i>
      </div>
      <h1>Add New Profile Audit</h1>
      <p>Enter a public Instagram or TikTok profile to analyze their audience and engagement</p>
    </div>

    <!-- Platform Selector -->
    <div class="platform-selector" *ngIf="size() === 'large'">
      <button
        type="button"
        class="platform-card"
        [class.active]="channelType === 'instagram'"
        (click)="setChannelType('instagram')"
      >
        <div class="platform-icon instagram">
          <i class="bi bi-instagram"></i>
        </div>
        <span class="platform-name">Instagram</span>
        <i class="bi bi-check-circle-fill check-icon" *ngIf="channelType === 'instagram'"></i>
      </button>

      <button
        type="button"
        class="platform-card"
        [class.active]="channelType === 'tiktok'"
        (click)="setChannelType('tiktok')"
      >
        <div class="platform-icon tiktok">
          <i class="bi bi-tiktok"></i>
        </div>
        <span class="platform-name">TikTok</span>
        <i class="bi bi-check-circle-fill check-icon" *ngIf="channelType === 'tiktok'"></i>
      </button>
    </div>

    <!-- Profile Input -->
    <div class="profile-input-section">
      <label class="input-label" *ngIf="size() === 'large'">
        <i class="bi bi-at"></i>
        Enter {{ channelType === 'instagram' ? 'Instagram' : 'TikTok' }} username
      </label>

      <div class="profile-input-wrapper">
        <div class="input-prefix">
          <ng-container *ngIf="channelType === 'instagram'">
            <i class="bi bi-instagram"></i>
            <span class="prefix-url">instagram.com/</span>
          </ng-container>
          <ng-container *ngIf="channelType === 'tiktok'">
            <i class="bi bi-tiktok"></i>
            <span class="prefix-url">tiktok.com/&#64;</span>
          </ng-container>
        </div>
        <input
          formControlName="profile"
          (paste)="onPaste($event)"
          type="text"
          placeholder="username"
          autocomplete="off"
          spellcheck="false"
        >
      </div>

      <p class="input-hint" *ngIf="size() === 'large'">
        <i class="bi bi-info-circle"></i>
        You can also paste a full profile URL - we'll extract the username automatically
      </p>
    </div>

    <!-- Submit Button -->
    <div class="submit-section">
      <button
        type="submit"
        class="btn-generate"
        [disabled]="!profileForm.valid || !(profileState | async).loader['auditAdd']['add']"
        [class.loading]="!(profileState | async).loader['auditAdd']['add']"
      >
        <span class="btn-content" *ngIf="(profileState | async).loader['auditAdd']['add']">
          <i class="bi bi-search"></i>
          Generate Report
        </span>
        <span class="btn-loading" *ngIf="!(profileState | async).loader['auditAdd']['add']">
          <span class="spinner"></span>
          Analyzing...
        </span>
      </button>

      <p class="credits-info" *ngIf="size() === 'large' && !hasLimit">
        <i class="bi bi-info-circle"></i>
        You have no credits. This audit will be added as a <strong>trial</strong>.
      </p>
    </div>

  </form>
</div>
